export default __webpack_public_path__ + "static/media/study-materials.095c61b0.svg";